// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1",
  firstName: "MJ",
  middleName: "",
  lastName: "LEE",
  message: "Providing finTech services and solutions via blockchain.",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/mjkid221",
    },
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/minjae-mj-lee-23695918b/",
    },
    {
      image: "fa-twitter",
      url: "https://twitter.com/mjlee221",
    },
  ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/hashirshoaeb.png"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/avatar.jpeg"),
  imageSize: 375,
  message: "",
  resume: require("../editable-stuff/resume.pdf"),
};

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
const repos = {
  show: true,
  heading: "Recent Projects & Contributions",
  gitHubUsername: "mjkid221", //i.e."johnDoe12Gh"
  reposLength: 8,
  specificRepos: [
    "gix-exchange",
    "swell-staking-vault",
    "sns-manager",
    "sweeter",
    "covid-shopper-app",
    "kaktana-react-lightweight-charts",
    "UniV1_Substrate_Ink",
    "UniV2_Substrate_Ink",
  ],
};

// SKILLS SECTION
const skills = {
  show: true,
  heading: "My Latest CV",
  hardSkills: [
    { name: "JavaScript", value: 94 },
    { name: "TypeScript", value: 90 },
    { name: "Solidity", value: 96 },
    { name: "C", value: 45 },
    { name: "Python", value: 65 },
    { name: "React", value: 83 },
    { name: "HTML/CSS", value: 58 },
    { name: "Rust", value: 72 },
  ],
  softSkills: [
    { name: "Goal-Oriented", value: 80 },
    { name: "Collaboration", value: 90 },
    { name: "Positivity", value: 75 },
    { name: "Adaptability", value: 85 },
    { name: "Problem Solving", value: 75 },
    { name: "Empathy", value: 90 },
    { name: "Organization", value: 70 },
    { name: "Creativity", value: 90 },
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message:
    "Interested in collaborating with me or want to discuss about work opportunities? Contact me at",
  email: "mjkid221@gmail.com",
};

const experiences = {
  show: true,
  heading: "Experiences",
  data: [
    {
      role: "EAIT Student Ambassador", // Here Add Company Name
      companylogo: require("../assets/uq.jpeg"),
      date: "Jan 2019 – Jan 2020",
      website: "https://www.uq.edu.au/",
    },
    {
      role: "Freelance Software Engineer",
      companylogo: require("../assets/freelance.png"),
      date: "Jan 2021 - Feb 2022",
    },
    {
      role: "Full Stack & Blockchain Developer",
      companylogo: require("../assets/labrys.png"),
      date: "Apr 2022 – Current",
      website: "https://labrys.io/",
    },
  ],
};

const presentations = {
  show: true,
  heading: "My Latest Talks",
  data: [
    {
      role: "Monolithic & Modular Designs in Blockchain",
      companylogo: require("../assets/modular.png"),
      website:
        "https://docs.google.com/presentation/d/1_p4ZyqipJzsP6-lcBk3y08LjDH1gOgyqQAv7VfQx5G8/edit?usp=sharing",
    },
    {
      role: "ERC-4337: Account Abstraction",
      companylogo: require("../assets/abstraction.png"),
      website:
        "https://docs.google.com/presentation/d/1ROVyxsZZBiR394qT8F_Zc-AV-DxF61_r_tTpNFA1Vkw/edit?usp=sharing",
    },
    {
      role: "Ethereum & Solana's Model: A Comparative Deep Dive",
      companylogo: require("../assets/solanaland.png"),
      website:
        "https://docs.google.com/presentation/d/13-RfwgPzSfjDpJtsvKvJJm-HwEbIHtcgojogIsPxHrM/edit?usp=sharing",
    },
  ],
};

export {
  navBar,
  mainBody,
  about,
  repos,
  skills,
  getInTouch,
  experiences,
  presentations,
};
